import React from 'react';
import { GenericListPage } from '../../components/generic';
import { useCrmNotes, CrmNote } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<CrmNote>
      useData={useCrmNotes}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
        toolbar: {
          ...moduleConfig.toolbar,
          viewToggle: {
            enabled: false,
            views: [
              { key: 'card', label: 'Cardboard View', icon: 'card', href: '/cardboard-crm-notes' },
            ],
          },
          actions: [
            {
              key: 'cardboard-view',
              icon: 'card',
              title: 'Cardboard View',
              showTitle: false,
              variant: 'default' as const,
              position: 'beforeTablePresets' as const,
              href: '/cardboard-crm-notes',
            },
            ...(moduleConfig.toolbar.actions ?? []),
          ],
        },
      }}
    />
  );
};

export default List;

